import { useEffect, useState } from "react";
import Select from "react-select";
import {
  fetchFasesTrabajo,
  createCategoriaNombreImagen,
  updateCategoriaNombreImagen,
  getCategoriasReportes,
} from "../../components/functions/Projects";
import LoaderDialog from "../../ui/loader/Loader";
import { DialogActions, Typography, Snackbar, Dialog } from "@mui/material";
import CustomButton from "../../ui/button/Button";

const EDTCategoriaImagenModal = ({
  API_URL,
  open,
  handleClose,
  selectedEDT,
  edit = false,
  categoria = null,
  selectedFaseDeTrabajo = null,
}) => {
  const [showLoader, setShowLoader] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [categoriasReportes, setCategoriasReportes] = useState([]);

  const [fasesDeTrabajo, setFasesDeTrabajo] = useState([]);

  const [categoriaForm, setCategoriaForm] = useState({
    nombre: "",
    categoriaParametro: selectedFaseDeTrabajo,
    tipoTrabajo: {
      id: null,
    },
    categoriaReporte: null,
    categoriaReporteDescripcion: null,
    categoriaReporteId: null,
    categoriaReporteNombre: null,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        setShowLoader(true);

        const [fasesRes, categoriasRes] = await Promise.all([
          fetchFasesTrabajo(API_URL, selectedEDT.id),
          getCategoriasReportes(API_URL, selectedEDT.id),
        ]);

        fasesRes.forEach((fase) => {
          if (fase.descripcion === "Entregable") {
            fase.descripcion = "Implementación";
          }
        });

        setFasesDeTrabajo(fasesRes);
        setCategoriasReportes(categoriasRes);
        setShowLoader(false);
      } catch (error) {
        setShowLoader(false);
        setSnackbarMessage("Ocurrió un error al obtener los datos.");
      }
    };
    if (open && selectedEDT) {
      if (edit && categoria) {
        if (categoriasReportes.length > 0) {
          const categoriaReporteSeleccionada = categoriasReportes.find(
            (cat) => cat.id === categoria.categoriaReporteId
          );
          setCategoriaForm({
            ...categoria,
            categoriaReporte: categoriaReporteSeleccionada || null,
          });
          return;
        } else {
          setCategoriaForm({
            ...categoria,
            categoriaReporte: null,
          });
          return;
        }
      } else {
        setCategoriaForm({
          nombre: "",
          categoriaParametro: selectedFaseDeTrabajo,
          tipoTrabajo: {
            id: selectedEDT.id,
          },
          categoriaReporte: null,
          categoriaReporteDescripcion: null,
          categoriaReporteId: null,
          categoriaReporteNombre: null,
        });
      }

      fetchData();
    }
    // eslint-disable-next-line
  }, [open, selectedEDT]);

  const onClose = () => {
    handleClose();
    setCategoriaForm({
      nombre: "",
      categoriaParametro: null,
      tipoTrabajo: {
        id: null,
      },
      categoriaReporte: null,
      categoriaReporteDescripcion: null,
      categoriaReporteId: null,
      categoriaReporteNombre: null,
    });
    setShowLoader(false);
  };

  async function crearCategoria() {
    if (categoriaForm.nombre.trim() === "") {
      setShowSnackbar(true);
      setSnackbarMessage("El nombre de la categoría de imagen es obligatorio.");
      return;
    }
    if (categoriaForm.categoriaParametro === null) {
      setShowSnackbar(true);
      setSnackbarMessage("La categoría de imagen es obligatoria.");
      return;
    }

    if (
      categoriaForm.categoriaReporte === null &&
      categoriasReportes.length > 0
    ) {
      setShowSnackbar(true);
      setSnackbarMessage("La categoría de reporte es obligatoria.");
      return;
    }

    if (categoriaForm.categoriaReporte && categoriaForm.categoriaReporte.id) {
      categoriaForm.categoriaReporteId = categoriaForm.categoriaReporte.id;
    }

    if (categoriaForm.categoriaParametro.descripcion === "Implementación") {
      categoriaForm.categoriaParametro.descripcion = "Entregable";
    }

    try {
      setShowLoader(true);
      if (edit) {
        await updateCategoriaNombreImagen(API_URL, categoriaForm);
      } else {
        await createCategoriaNombreImagen(API_URL, categoriaForm);
      }
      setShowLoader(false);
      onClose();
    } catch (error) {
      setShowLoader(false);
      setShowSnackbar(true);
      setSnackbarMessage(
        `Ocurrió un error al ${
          edit ? "actualizar" : "crear"
        } la categoría de imagen.`
      );
    }
  }

  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        onClose={onClose}
        open={open}
        disableEnforceFocus
        height={"500px"}
      >
        <Snackbar
          open={showSnackbar}
          autoHideDuration={3000}
          onClose={() => {
            setShowSnackbar(false);
            setSnackbarMessage("");
          }}
          message={snackbarMessage}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          slotProps={{
            content: {
              sx: {
                backgroundColor: "white",
                color: "#222",
                justifyContent: "center",
                textAlign: "center",
                fontWeight: "bold",
                fontSize: "16px",
                fontFamily: "Roboto, Arial, sans-serif",
              },
            },
          }}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            margin: "0 0 120px 0",
            padding: "12px",
          }}
        >
          <h2>{edit ? "Editar" : "Crear"} categoría de imagen</h2>
          <label htmlFor="name2" className="form-label form-label-left">
            Nombre:
          </label>
          <input
            id="name2"
            className="form-input"
            type="text"
            name="nombre"
            placeholder="Ingresa el nombre..."
            value={categoriaForm.nombre}
            onChange={(e) =>
              setCategoriaForm((prev) => ({ ...prev, nombre: e.target.value }))
            }
          />

          {edit && (
            <label
              htmlFor="categoriaImagen"
              className="form-label form-label-left"
              style={{ margin: "6px 0" }}
            >
              Fase de trabajo:
            </label>
          )}
          {edit ? (
            <Select
              options={fasesDeTrabajo.map((fase) => ({
                value: fase.name,
                label: fase.descripcion,
              }))}
              onChange={(e) =>
                setCategoriaForm((prev) => ({
                  ...prev,
                  categoriaParametro: fasesDeTrabajo.find(
                    (fase) => fase.name === e.value
                  ),
                }))
              }
              placeholder="Fase de trabajo..."
              classNamePrefix="react-select"
              styles={{
                dropdownIndicator: (provided) => ({
                  ...provided,
                  color: "#62C776",
                  cursor: "pointer",
                }),
                indicatorSeparator: () => ({ display: "none" }),
                option: (provided, state) => ({
                  ...provided,
                  color: "#000",
                  backgroundColor: state.isSelected ? "#e0e0e0" : "white",
                  cursor: "pointer",
                  fontSize: "14px",
                }),
                control: (provided) => ({
                  ...provided,
                  cursor: "pointer",
                  fontSize: "14px",
                }),
                menu: (provided) => ({ ...provided, height: "120px" }),
                menuList: (provided) => ({
                  ...provided,
                  height: "120px",
                  textAlign: "left",
                }),
              }}
              value={
                fasesDeTrabajo
                  .map((fase) => {
                    return {
                      value: fase.name,
                      label: fase.descripcion,
                    };
                  })
                  .find(
                    (option) =>
                      option.label ===
                      categoriaForm?.categoriaParametro?.descripcion
                  ) || null
              }
              inputId="categoriaImagen"
            />
          ) : (
            <Typography sx={{ color: "#223d51", mb: "12px" }} variant="body1">
              Fase de trabajo: {selectedFaseDeTrabajo?.descripcion}
            </Typography>
          )}

          <label
            htmlFor="categoriaReporteP"
            className="form-label form-label-left"
          >
            Categoría de reporte:
          </label>
          <Select
            options={categoriasReportes.map((cat) => ({
              value: cat.id,
              label: cat.nombre,
            }))}
            onChange={(e) =>
              setCategoriaForm((prev) => ({
                ...prev,
                categoriaReporte: categoriasReportes.find(
                  (cat) => cat.id === e.value
                ),
              }))
            }
            placeholder="Categoría de reporte..."
            classNamePrefix="react-select"
            styles={{
              dropdownIndicator: (provided) => ({
                ...provided,
                color: "#62C776",
                cursor: "pointer",
              }),
              indicatorSeparator: () => ({ display: "none" }),
              option: (provided, state) => ({
                ...provided,
                color: "#000",
                backgroundColor: state.isSelected ? "#e0e0e0" : "white",
                cursor: "pointer",
                fontSize: "14px",
              }),
              control: (provided) => ({
                ...provided,
                cursor: "pointer",
                fontSize: "14px",
              }),
              menu: (provided) => ({ ...provided, height: "120px" }),
              menuList: (provided) => ({
                ...provided,
                height: "120px",
                textAlign: "left",
              }),
            }}
            value={
              categoriasReportes
                .map((cat) => {
                  return {
                    value: cat.id,
                    label: cat.nombre,
                  };
                })
                .find(
                  (option) =>
                    option.value === categoriaForm?.categoriaReporte?.id
                ) || null
            }
            inputId="categoriaReporteP"
          />
        </div>
        <DialogActions>
          <CustomButton
            background={"#FFFFFF"}
            color={"#223D51"}
            text="Cerrar"
            height="40px"
            fontWeight="700"
            fontSize="14px"
            border="1px solid #D9D9D9"
            onClick={onClose}
            type="button"
          />
          <CustomButton
            background={"#223D51"}
            color={"#FFFFFF"}
            text="Guardar"
            height="40px"
            fontWeight="700"
            fontSize="14px"
            border="1px solid #D9D9D9"
            onClick={() => {
              crearCategoria();
            }}
            type="button"
          />
        </DialogActions>
      </Dialog>
      <LoaderDialog open={showLoader} />
    </>
  );
};

export default EDTCategoriaImagenModal;
